import LocationInput from './location_input';
export default LocationInput;
